import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M9 14.14V9.86L5.97 12zm9 0V9.86L14.97 12z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m11 6-8.5 6 8.5 6V6zm-2 8.14L5.97 12 9 9.86v4.28zM20 6l-8.5 6 8.5 6V6zm-2 8.14L14.97 12 18 9.86v4.28z"
}, "1")], 'FastRewindTwoTone');